// extracted by mini-css-extract-plugin
export default {"root":"OlympDataCard_root__Lj5E1","rootTypeContacts":"OlympDataCard_rootTypeContacts__oP40n"};